export default {
    // global actions
}